import React from 'react';
import PropTypes from 'prop-types';

export default function ExpertPanel({ experts }) {
  if (!experts || experts.length === 0) {
    return <p>No expert feedback available.</p>;
  }

  return (
    <div className="row">
      {experts.map((expert, index) => {
        const items = expert.critiques || expert.suggestions || [];
        const questions = expert.questions_for_gpt || [];
        const hasQuote = !!expert.reason;

        return (
          <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
            <div className="card h-100 shadow border-0" style={{ background: '#f9fbff' }}>
              <div className="card-body d-flex flex-column">
                <div className="mb-3">
                  <div className="text-primary fw-bold" style={{ fontSize: '1.1rem' }}>
                    {expert.expert_name}
                  </div>
                </div>

                <ul className="ps-3 mb-3" style={{ fontSize: '0.95rem' }}>
                  {items.map((item, idx) => (
                    <li key={idx} className="mb-2">{item}</li>
                  ))}
                </ul>

                {hasQuote && (
                  <div
                    className="small fst-italic text-muted px-3 py-2 mb-3 rounded"
                    style={{
                      background: '#eef2fa',
                      borderLeft: '4px solid #93c5fd'
                    }}
                  >
                    {expert.reason}
                  </div>
                )}

                {questions.length > 0 && (
                  <div className="mt-auto">
                    <h6 className="fw-semibold mb-2 text-secondary">Questions for AI</h6>
                    <ul className="small ps-3 mb-0">
                      {questions.map((q, idx) => (
                        <li key={idx}>{q}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

ExpertPanel.propTypes = {
  experts: PropTypes.arrayOf(
    PropTypes.shape({
      expert_name: PropTypes.string.isRequired,
      critiques: PropTypes.arrayOf(PropTypes.string),
      suggestions: PropTypes.arrayOf(PropTypes.string),
      reason: PropTypes.string,
      questions_for_gpt: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired
};
